"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockFace = exports.trajectoryInfo = exports.projectileAirResistance = exports.projectileGravity = void 0;
exports.projectileGravity = {
    arrow: 0.05,
    trident: 0.05,
    egg: 0.03,
    snowball: 0.03,
    ender_pearl: 0.03,
    potion: 0.05,
    firework_rocket: 0.0,
    fishing_bobber: 0.03,
};
exports.projectileAirResistance = {
    arrow: 1 - 0.99,
    trident: 1 - 0.99,
    egg: 1 - 0.99,
    snowball: 1 - 0.99,
    ender_pearl: 1 - 0.99,
    potion: 1 - 0.99,
    firework_rocket: 1 - 0.99,
    fishing_bobber: 1 - 0.92,
};
exports.trajectoryInfo = {
    bow: { v0: 3, g: exports.projectileGravity["arrow"], ph: 1.62, a: exports.projectileAirResistance["arrow"] },
    crossbow: { v0: 3.15, g: exports.projectileGravity["arrow"], ph: 1.62, a: exports.projectileAirResistance["arrow"] },
    crossbow_firework: { v0: 1.6, g: exports.projectileGravity["firework_rocket"], ph: 1.62, a: exports.projectileAirResistance["firework_rocket"] },
    trident: { v0: 2.5, g: exports.projectileGravity["trident"], ph: 1.62, a: exports.projectileAirResistance["trident"] },
    snowball: { v0: 1.5, g: exports.projectileGravity["snowball"], ph: 1.52, a: exports.projectileAirResistance["snowball"] },
    egg: { v0: 1.5, g: exports.projectileGravity["egg"], ph: 1.52, a: exports.projectileAirResistance["egg"] },
    ender_pearl: { v0: 1.5, g: exports.projectileGravity["ender_pearl"], ph: 1.52, a: exports.projectileAirResistance["ender_pearl"] },
    potion: { v0: 0.4, g: exports.projectileGravity["potion"], ph: 1.52, a: exports.projectileAirResistance["potion"] },
    fishing_rod: { v0: 1.5, g: exports.projectileGravity["fishing_bobber"], ph: 1.62, a: exports.projectileAirResistance["fishing_bobber"] }, // TODO: nake v0 variable dependent on yaw and pitch.
};
var BlockFace;
(function (BlockFace) {
    BlockFace[BlockFace["UNKNOWN"] = -999] = "UNKNOWN";
    BlockFace[BlockFace["BOTTOM"] = 0] = "BOTTOM";
    BlockFace[BlockFace["TOP"] = 1] = "TOP";
    BlockFace[BlockFace["NORTH"] = 2] = "NORTH";
    BlockFace[BlockFace["SOUTH"] = 3] = "SOUTH";
    BlockFace[BlockFace["WEST"] = 4] = "WEST";
    BlockFace[BlockFace["EAST"] = 5] = "EAST";
})(BlockFace = exports.BlockFace || (exports.BlockFace = {}));
